export type QueriesApi = {
  page:number | null | undefined,
  pageSize?:number | null | undefined,
  ordering?:string | null | undefined,
  page_size?:number | null | undefined,
  search?:string | null | undefined,
  active_client?:number | null | undefined,
  service_id?:string | number | null | undefined,
  tags?:any[],
}

export const getListParams = (queries:QueriesApi) => ({
  page: queries.page,
  page_size: queries.page_size ?? queries.pageSize,
  ordering: queries.ordering || undefined,
  search: queries.search || undefined,
  active_client: queries.active_client,
})
